var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66448 13.2176H14.483C15.3174 13.2176 16 12.535 16 11.7006V2.40911C16 1.57473 15.3174 0.89209 14.483 0.89209H1.66448C0.830103 0.89209 0.147461 1.57473 0.147461 2.40911V11.7006C0.147593 12.535 0.830103 13.2176 1.66448 13.2176ZM1.66448 11.7006V3.11071L7.56175 8.32534C7.71346 8.45814 7.88409 8.51502 8.05473 8.51502C8.22538 8.51502 8.41505 8.45814 8.54772 8.32534L14.445 3.11071V11.7006H1.66448ZM3.16257 2.40911H12.985L8.0738 6.75147L3.16257 2.40911Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.e229a4f3.svg";
export { ForwardRef as ReactComponent };